import toQueryParams from '../../utils/toQueryParams';
import claimScoreApiServiceClient from '../client';
import { ValidateTokenResponse } from '../shared/types';
import {
  AccountActiveSearchResultsResponse,
  AccountCasesResponse,
  AccountOrganizationsResponse,
} from './types';

export const getAccountCasesByOrganization = async (
  organizationId: string,
): Promise<AccountCasesResponse> => {
  const { data } = await claimScoreApiServiceClient.get(
    `accounts/cases/${organizationId}`,
  );

  return data;
};

export const getAccountCases = async (
  pageNumber: number,
): Promise<AccountCasesResponse> => {
  const { data } = await claimScoreApiServiceClient.get(
    `accounts/cases?${toQueryParams({ pageNumber, pageSize: 12 })}`,
  );
  return data;
};

export const getAccountOrganizations =
  async (): Promise<AccountOrganizationsResponse> => {
    const { data } = await claimScoreApiServiceClient.get(
      'accounts/organizations',
    );

    return data;
  };

export const getAccountActiveSearchResults = async (
  searchValue: string,
): Promise<AccountActiveSearchResultsResponse> => {
  const { data } = await claimScoreApiServiceClient.get(
    `/accounts/activeSearch/${searchValue}`,
  );

  return data;
};

export const getAccountActiveSearchForCaseResults = async (
  caseId: string,
  searchValue: string,
): Promise<AccountActiveSearchResultsResponse[]> => {
  const { data } = await claimScoreApiServiceClient.get(
    `/accounts/activeSearchForCase/${caseId}?searchValue=${searchValue}`,
  );

  return data;
};

export const sendResetPasswordEmail = async (email: string) => {
  const { data } = await claimScoreApiServiceClient.post(
    '/accounts/reset-password/send-email',
    { email },
  );

  return data;
};

export const validateResetPasswordToken = async (
  token: string,
  email: string,
): Promise<ValidateTokenResponse> => {
  const { data } = await claimScoreApiServiceClient.post(
    `/accounts/reset-password/validate-token/${token}`,
    { email },
  );

  return data;
};
